import { render } from "./CreateTeam.vue?vue&type=template&id=a9f2b4a8&scoped=true"
import script from "./CreateTeam.vue?vue&type=script&lang=js"
export * from "./CreateTeam.vue?vue&type=script&lang=js"

import "./CreateTeam.vue?vue&type=style&index=0&id=a9f2b4a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f2b4a8"]])

export default __exports__